module.exports = __webpack_public_path__ + "static/media/jangba1.ae2a43b1.jpg";